// Newsletter subscription via vc-newsletter Cloudflare Worker.
// Bypasses Shopify's customer-create form (and its captcha) entirely —
// the worker calls the Shopify Admin API on the user's behalf.
//
// Hooks into any newsletter-style email form on the page (Horizon's
// email-signup or our custom footer block). On submit:
//   - Cancel the native form post
//   - POST { email, hp_website } to the worker URL
//   - Show ✓ on the button + inline confirmation on success
//   - Show inline error otherwise
//
// Worker URL is exposed via window.VC.newsletterWorkerUrl (set in
// vc-tokens.liquid from theme settings). If not configured, the script
// is a no-op (form falls back to native submission).

(function(){
  function workerUrl() {
    return (window.VC && window.VC.newsletterWorkerUrl) || '';
  }

  function isNewsletterForm(form) {
    var action = (form.getAttribute('action') || '').toLowerCase();
    if (action.indexOf('/contact') === -1) return false;
    if (!form.querySelector('input[name="contact[email]"]')) return false;
    if (form.querySelector('input[name="contact[name]"]')) return false; // skip /contact page
    return true;
  }

  function getBtn(form) {
    return form.querySelector('button[type="submit"], button:not([type])');
  }

  function showButtonCheck(btn) {
    if (!btn) return;
    if (!btn.dataset.vcOriginalHtml) btn.dataset.vcOriginalHtml = btn.innerHTML;
    btn.innerHTML = '<span aria-hidden="true" style="font-size:1.2em;line-height:1">✅</span>';
    btn.classList.add('vc-newsletter-success');
    btn.disabled = true;
  }

  function showInlineMessage(form, kind, text) {
    var box = form.querySelector('.vc-newsletter-feedback');
    if (!box) {
      box = document.createElement('p');
      box.className = 'vc-newsletter-feedback';
      box.setAttribute('role', kind === 'ok' ? 'status' : 'alert');
      form.appendChild(box);
    }
    box.dataset.kind = kind;
    box.textContent = text;
  }

  function ensureHoneypot(form) {
    if (form.querySelector('input[name="hp_website"]')) return;
    var hp = document.createElement('input');
    hp.type = 'text';
    hp.name = 'hp_website';
    hp.autocomplete = 'off';
    hp.tabIndex = -1;
    hp.setAttribute('aria-hidden', 'true');
    hp.style.cssText = 'position:absolute;left:-9999px;width:1px;height:1px;opacity:0;pointer-events:none;';
    form.appendChild(hp);
  }

  document.addEventListener('submit', async function(e) {
    var form = e.target.closest('form');
    if (!form || !isNewsletterForm(form)) return;
    var url = workerUrl();
    if (!url) return; // no worker configured — fall through to native submit
    e.preventDefault();
    e.stopPropagation();

    ensureHoneypot(form);
    var input = form.querySelector('input[name="contact[email]"]');
    var btn = getBtn(form);
    var hp = form.querySelector('input[name="hp_website"]');

    if (!input || !input.value || !input.checkValidity()) {
      showInlineMessage(form, 'err', 'Adresa de e-mail nu este validă.');
      if (input) input.focus();
      return;
    }

    if (btn) btn.classList.add('is-loading');
    try {
      var r = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: input.value.trim(),
          hp_website: hp ? hp.value : ''
        }),
      });
      if (btn) btn.classList.remove('is-loading');
      var data = {};
      try { data = await r.json(); } catch (_) {}
      if (r.ok && data.ok) {
        showButtonCheck(btn);
        if (input) input.disabled = true;
        showInlineMessage(form, 'ok', 'Te-ai înscris. Mulțumim!');
      } else {
        showInlineMessage(form, 'err', data.error || 'Ceva nu a mers. Încearcă din nou.');
      }
    } catch (err) {
      if (btn) btn.classList.remove('is-loading');
      showInlineMessage(form, 'err', 'Conexiune eșuată. Încearcă din nou.');
    }
  }, true);
})();
